'use client';
import React from 'react';
import { useModel } from '@/context/ModelContext';
import { fmtCrShort } from '@/lib/financial-model';
import InputRow from './InputRow';

export default function FixedCostsSection() {
  const { assumptions, updateAssumption, model } = useModel();

  return (
    <div>
      <InputRow
        label="Land Lease"
        unit="₹ / year"
        note="30-year registered lease for 10–12 acre parcel — scaled from 2 TPH baseline"
        confidence="High"
        value={assumptions?.landLease}
        onChange={(v) => updateAssumption('landLease', v)}
        min={500000}
        max={10000000}
        step={100000}
      />
      <InputRow
        label="Salaries & Admin (Fixed Staff)"
        unit="₹ / year"
        note="Plant Manager + 15–18 operators, supervisors, admin — ~1.75× the 2 TPH headcount"
        confidence="Medium"
        value={assumptions?.salaries}
        onChange={(v) => updateAssumption('salaries', v)}
        min={1000000}
        max={20000000}
        step={100000}
      />
      <InputRow
        label="Insurance, Security & Misc Fixed"
        unit="₹ / year"
        note="Plant insurance, security guard, miscellaneous fixed overheads"
        confidence="Medium"
        value={assumptions?.insuranceMisc}
        onChange={(v) => updateAssumption('insuranceMisc', v)}
        min={100000}
        max={5000000}
        step={50000}
      />
      <InputRow
        label="Total Fixed Cost (ex-Depreciation)"
        unit="₹ / year"
        note="Calculated: Land Lease + Salaries + Insurance"
        isCalculated
        calculatedValue={fmtCrShort(model?.totalFixedCostBase)}
        value={model?.totalFixedCostBase}
        onChange={() => {}}
      />
      <div className="mt-3 grid grid-cols-2 sm:grid-cols-5 gap-2">
        {[1, 2, 3, 5, 10]?.map((yr) => (
          <div key={`fc-yr-${yr}`} className="p-2 bg-muted/50 rounded-lg">
            <p className="text-xs text-muted-foreground">Yr {yr} Fixed</p>
            <p className="font-mono text-xs font-semibold text-foreground">
              {fmtCrShort(model?.years?.[yr]?.totalFixedCost ?? 0)}
            </p>
            <p className="text-xs text-muted-foreground">
              (+{(assumptions?.inflationFixedCosts * 100 * (yr - 1))?.toFixed(0)}% infl)
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
